import {
  APP_MANAGED_ROUTES,
  AuthSignIn,
  AuthSignOut,
} from '@highmark-web/highmark-common';
import { RouteObject } from 'react-router-dom';
import { BrandedLandingPage } from 'pages/branded-landing.page';
import { AllMyHealthLanguagePage } from 'pages/static/allmyhealth-language.page';

const signInPaths = [
  `${APP_MANAGED_ROUTES.SIGN_IN}/*`,
  `${APP_MANAGED_ROUTES.SIGN_IN_ALTERNATIVE}/*`,
  `${APP_MANAGED_ROUTES.START_LOGIN}/*`,
];

export const PublicRoutes: RouteObject[] = [
  ...signInPaths.map((path) => ({ path, element: <AuthSignIn /> })),
  {
    path: `${APP_MANAGED_ROUTES.SIGN_OUT}/*`,
    element: <AuthSignOut />,
  },
  {
    path: `${APP_MANAGED_ROUTES.TECHNICAL_ASSISTANCE_AND_ALL_LANGUAGES}/*`,
    element: <AllMyHealthLanguagePage />,
  },
  { path: '', element: <BrandedLandingPage /> },
];
